export default ({ axios, mapQueryString }) => ({
    index: (query = {}) => axios.get(`/tenders${mapQueryString(query)}`),
    show: (id = {}) => axios.get(`/tenders/${id}`),
    store: (data) => axios.post(`/tenders`, data),
    update: (id, data) => axios.patch(`/tenders/${id}`, data),
    delete: (id) => axios.delete(`/tenders/${id}`),
})